// Lightweight pub/sub event bus — no DOM dependency, synchronous dispatch
class GameEventBus {
  constructor() {
    this.listeners = new Map();
  }

  on(event, callback) {
    if (!this.listeners.has(event)) this.listeners.set(event, []);
    this.listeners.get(event).push(callback);
    return () => this.off(event, callback);
  }

  off(event, callback) {
    const list = this.listeners.get(event);
    if (list) this.listeners.set(event, list.filter(cb => cb !== callback));
  }

  emit(event, data) {
    const list = this.listeners.get(event);
    if (!list) return;
    for (let i = 0; i < list.length; i++) {
      try {
        list[i](data);
      } catch (err) {
        console.error(`[EventBus] Listener error on "${event}":`, err);
      }
    }
  }

  once(event, callback) {
    const wrapper = (data) => {
      this.off(event, wrapper);
      callback(data);
    };
    return this.on(event, wrapper);
  }
}

export const GameEvents = {
  // Interaction events
  CREATURE_CLICKED: 'creature:clicked',
  OBJECT_CLICKED: 'object:clicked',
  OBJECT_HOVERED: 'object:hovered',
  OBJECT_HOVER_END: 'object:hoverEnd',

  // Discovery events
  DISCOVERY_NEW: 'discovery:new',
  DISCOVERY_MILESTONE: 'discovery:milestone',

  // Resource events (Phase 2 ready)
  RESOURCE_SPAWNED: 'resource:spawned',
  RESOURCE_COLLECTED: 'resource:collected',

  // Inventory events
  INVENTORY_CHANGED: 'inventory:changed',

  // Crafting events (Phase 2 ready)
  CRAFT_STARTED: 'craft:started',
  CRAFT_COMPLETED: 'craft:completed',
  OBJECT_PLACED: 'object:placed',
  OBJECT_REMOVED: 'object:removed',

  // Placement mode events
  PLACEMENT_STARTED: 'placement:started',
  PLACEMENT_CANCELLED: 'placement:cancelled',

  // Creature events
  FRIENDSHIP_CHANGED: 'friendship:changed',
  FRIENDSHIP_LEVEL_UP: 'friendship:levelup',

  // Upgrade events
  UPGRADE_PURCHASED: 'upgrade:purchased',

  // Audio/VFX events
  PLAY_SOUND: 'audio:play',
  SPAWN_PARTICLES: 'vfx:particles',

  // State events
  SAVE_REQUESTED: 'save:requested',
  STATE_LOADED: 'state:loaded',
  STATE_SAVED: 'state:saved',
  SESSION_STARTED: 'session:started',
};

export const eventBus = new GameEventBus();
